import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Phone } from "lucide-react";
import { COMPANY } from "@/data/content";

export default function NotFound() {
  return (
    <section className="section min-h-[60vh] flex items-center">
      <div className="container-owrs">
        <div className="max-w-2xl">
          <div className="overline mb-4">Error 404</div>
          <h1 className="font-display text-6xl sm:text-7xl lg:text-8xl font-medium tracking-tighter leading-[0.95] mb-8">
            Wrong <span className="text-[var(--owrs-accent)]">turn</span>.
          </h1>
          <p className="text-lg text-[var(--owrs-text-muted)] leading-relaxed mb-10 max-w-xl">
            The page you were after isn't here. It may have moved or been retired.
            Take a look at the main pages below — or give us a call directly.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Link to="/" className="btn-primary">
              <ArrowLeft className="h-4 w-4" />
              Back to home
            </Link>
            <a href={`tel:${COMPANY.phoneTel}`} className="btn-secondary">
              <Phone className="h-4 w-4" />
              {COMPANY.phone}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
